<template>
    <div class="timeline">
        <el-form>
            <el-timeline>
                <el-timeline-item v-for="(item,index) in data" :key="index" :timestamp="item.diaryType === 2?('术后'+ (!item.afterDay && item.afterDay != 0 ? '' : item.afterDay)+'天'):'术前'" placement="top" color='#409EFF' type="primary" :class="item.diaryType == 2?'':'hBefore'">
                    <el-card>
                        <div class="timeline-card">
                            <el-switch v-model="item.isHide" :active-value="false" :inactive-value="true" active-text="显示" inactive-text="隐藏"  @change="showHideDiary($event,item.id)"/>
                            <p>发布时间 {{item.createTime}}</p>
                            <h4>{{item.content}}</h4>
                            <div class="filter-item" v-if="item.pictures && (item.pictures instanceof Array)">
                                <div class="demonstration">{{item.diaryType === 2 ? '术后图片' :'术前图片'}}</div>
                                <div class="img">
                                    <div v-for="(img,index) in item.pictures" :key="index" >
                                        <img  :src="img" />
                                    </div>
                                </div>
                            </div>
                            <div class="filter-item" v-if="item.pictures && item.pictures !== ''">
                                <div class="demonstration">{{item.diaryType === 2 ? '术后图片' :'术前图片'}}</div>
                                <div class="img">
                                    <div v-for="(img,index) in item.pictures.split(',')" :key="index" >
                                        <img  :src="getFullImageURLDiary(img)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-timeline-item>
            </el-timeline>
        </el-form>
    </div>
</template>

<script>
import { getFullImageURLDiary } from '@/utils/helper'
export default {
    name: 'timeline',
    props:{
        data:{type:Array,default:[]},
    },
    data() {
        return {
            value: true
        }
    },
    methods:{
       getFullImageURLDiary,
        showHideDiary(e,id){
            let param={
                id:id,
                isHide:e
            }
            this.$emit("changeShow", param);
        }
    }
}
</script>

<style lang="less" scoped>

.timeline {
  margin-left: 40px;
}
.timeline-card {
  h4 {
    display: inline-block;
    margin: 10px 0;
  }
}
.el-switch {
  margin-bottom: 10px;
}
.filter-item {
  width: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  .img {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-right: 20px;
    div {
      width: 160px;
      height: 160px;
      border-radius: 8px;
      margin-right: 10px;
      overflow: hidden;
      &:last-child {
        margin-right: 0px;
      }
      img{
          width:100%;
          min-height: 100%;
      }
    }
  }
}
</style>
<style lang="less">
.el-timeline-item__timestamp.is-top {
  position: absolute;
  left: -30px;
  // background: #409eff;
  color: #fff;
  padding: 0 8px !important;
  text-align: center;
  border-radius: 16px;
  line-height: 20px;
}
.el-timeline-item__wrapper {
  padding-left: 50px !important;
}
.el-timeline .el-card {
//   box-shadow: none;
  border: none;
  padding-top:20px;
  .el-card__body {
    padding: 0 20px 20px;
  }
  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
  }
  .el-switch__label--right {
    z-index: 1;
    right: -3px;
  }
  .el-switch__label--left {
    z-index: 1;
    left: 19px;
  }
  .el-switch__label.is-active {
    display: block;
  }
  .el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
  }
}
.el-timeline-item__tail {
  border-left: 2px solid #409eff;
}
.hBefore .el-timeline-item__timestamp.is-top{
    left:-15px;
}
</style>
